// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__OINQ9","description":"MealItem_description__-hO8n","price":"MealItem_price__lSNl3"};